import { render, staticRenderFns } from "./page-watch.vue?vue&type=template&id=76172c90&scoped=true"
import script from "./page-watch.vue?vue&type=script&lang=js"
export * from "./page-watch.vue?vue&type=script&lang=js"
import style0 from "./page-watch.vue?vue&type=style&index=0&id=76172c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76172c90",
  null
  
)

export default component.exports